import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { PlacementArray } from '@ng-bootstrap/ng-bootstrap/util/positioning';
import { AreaOfUse } from '../../../../../core/model';

@Component({
  selector: 'py-area-of-use-admin-delete-category-popover',
  templateUrl: './area-of-use-admin-delete-category-popover.component.html',
  styleUrls: ['./area-of-use-admin-delete-category-popover.component.scss'],
  standalone: false,
})
export class AreaOfUseAdminDeleteCategoryPopoverComponent {
  @Output() confirmDeletion = new EventEmitter<void>();
  @Input() areaOfUseCategory: AreaOfUse;
  @Input() placement?: PlacementArray = 'bottom';
  @Input() isSection = false;
  @Input() disabled = false;

  @ViewChild('popOver', { static: false }) popover: NgbPopover;

  closePopover(): void {
    this.popover.close();
  }

  delete(): void {
    this.confirmDeletion.emit();
  }
}
